/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeV2HeaderBannerData } from './moe-v2-header-banner.data';
import { IMoeV2HeaderBannerProps } from './moe-v2-header-banner.props.autogenerated';

export interface IMoeV2HeaderBannerViewProps extends IMoeV2HeaderBannerProps<IMoeV2HeaderBannerData> {}

/**
 *
 * MoeV2HeaderBanner component
 * @extends {React.PureComponent<IMoeV2HeaderBannerProps<IMoeV2HeaderBannerData>>}
 */
class MoeV2HeaderBanner extends React.PureComponent<IMoeV2HeaderBannerProps<IMoeV2HeaderBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2HeaderBanner;
